import { firstValueFrom } from 'rxjs';
import getSearchBarResults$ from '../apis/getSearchResults';

/**
 * Service class for managing search bar functionalities such as rendering results,
 * fetching data, and handling user location.
 */
class SearchBarService {
  /**
   * Fetches search results from the API based on the provided search text.
   * @param {string} searchText - The current search text input by the user.
   * @returns {Promise<Object|null>} - A promise that resolves to the search results or null in case of an error.
   */
  static fetchSearchResults(searchText) {
    return firstValueFrom(getSearchBarResults$(searchText))
      .then(response => {
        if (response?.error) {
          return null;
        }
        return response;
      })
      .catch(() => null);
  }
}

export default SearchBarService;
